module.exports = __webpack_public_path__ + "static/media/person.850fda71.svg";